<template>
    <div>
        <div class="title">
            <p>绑定手机号</p>
            <p @click="go">跳过</p>
        </div>
        
        <input v-model="number" type="text" id="input" placeholder="请输入手机号">
        <input v-model="code" type="text" placeholder="请输入验证码">

        <van-button round type="info" @click="verify" v-show="ashow">获取验证码</van-button>

        <div v-show="!ashow" class="count">{{count}}s后获取</div>

        <van-button type="primary" size="large" @click="affirm">确认绑定</van-button>
    </div>
</template>

<script>
import URL from '../api/index'
import Vue from 'vue';
import { Button } from 'vant';
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Button);
export default {
    data(){
        return{
            value: '',
            number:'',
            code:'',
            ashow: true,
            count: '',
            timer: null
        }
    },
    methods:{
        go(){
            this.$router.push('/')
        },
        verify(){
            this.$axios({
            method:'post',
            url:URL.get_user_vcode,
            data:{
                mobile:this.number
            }
            }).then((res)=>{
                console.log(res);
                
                Toast('发送成功');
            })
            //倒计时
            const TIME_COUNT = 60;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.ashow = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.ashow = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000)
            }
        },
        affirm(){
            if (localStorage.getItem("userInfo")) {
                console.log(localStorage.getItem("userInfo"))
                this.userInfo = JSON.parse(localStorage.getItem("userInfo"))
            }  
            var token = this.userInfo.token 
            console.log(token);
                    
            this.$axios({
            method:'post',
            url:URL.bindmobile,
            data:{
                token:token,
                mobile:this.number,
                code:this.code
            }
            }).then((res)=>{
                console.log(res.data.state);

                if(res.data.state == '1'){
                    console.log(1);
                    Toast(res.data.msg)
                    return
                }

                if(res.status === 200){
                    this.$router.push('/')
                }
            })
        }
    }
}
</script>

<style scoped>
p{
    margin: 0;
}
.title{
    line-height: 50px;
    text-align: center;
    font-size: 16px;
    border-bottom: 1px solid #f2f2f2;
}
.title p:last-child{
    position: absolute;
    top: 0;
    right: 15px;
}
#input{
    margin-top: 30px;
}
input{
    width: 100%;
    border: none;
    border-bottom: 1px solid #f2f2f2;
    line-height: 44px;
    text-indent: 2em;
    font-size: 16px;
    color: #000;
}
.van-button /deep/{
    position: absolute;
    top: 136px;
    right: 14px;
    display: inline-block;
    height: 30px;
    padding: 0 5px;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    border-radius: 14px;
    cursor:pointer;
}
.van-button:last-child{
    width: 90%;
    margin-left: 5%;
    position: absolute;
    top: 200px;
    height: 40px;
    border-radius: 20px;
    font-size: 18px;
}
.count{
    position: absolute;
    top: 136px;
    right: 14px;
    background-color: #1989fa;
    width: 82px;
    line-height: 30px;
    text-align: center;
    border-radius: 15px;
    font-size: 12px;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/bangdingsh.vue